/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useState, useEffect } from "react";
import { Col, Form, Input, Select, DatePicker } from "antd";
import { StyledTitle } from "../../../../../components/styled-antd";
import { INPUT_TYPE } from "../constant";
import { EMajorSelect } from "../components";
import { ECourseSelect } from "../components/eCourseSelect";
import { ETrainingTypeSelect } from "../components/eTrainingTypeSelect";
import moment from "moment";
import { useSelector } from "../../../../../store/store";
import { AlternateApproverSelect } from "../../../../../components";
import { department as departments } from "../../../info-technology-process/data";
import { StyledButton } from "../../../../../components/styled-antd";
import { useHistory } from "react-router-dom";
import { unitTSN, unitNB, unitDN } from "../../../info-technology-process/data";
import { FontFa } from "../../../../../components";
import { requestStatus } from "../../../../../constants";
import { getDDMMYYYFormat } from "../../../../../helper/dateTimeHelper";
import { getHHmmFormat } from "../../../../../helper/dateTimeHelper";

const { TextArea } = Input;

export function RenderHelper({
  fields,
  form,
  allValue,
  setAllValue,
  disabledAll,
  mode,
}: {
  fields: any[];
  form?: any;
  allValue?: any;
  setAllValue?: any;
  disabledAll?: boolean;
  mode?: string;
}) {
  return (
    <>
      {fields.map((value, index) => {
        if (value.field === "eMajor") {
          return (
            <Col span={value.span}>
              <StyledTitle level={5}>
                {value.label}{" "}
                {value.require && <span className="text-danger ml-1">(*)</span>}
              </StyledTitle>
              <Form.Item
                name={value.field}
                rules={[
                  {
                    required: value.require,
                    message: `Chọn ${value.label.toLowerCase()}`,
                  },
                ]}
              >
                <EMajorSelect
                  form={form}
                  allValue={allValue}
                  setAllValue={setAllValue}
                  disabledAll={disabledAll}
                />
              </Form.Item>
            </Col>
          );
        }

        if (value.field === "eCourse") {
          return (
            <Col span={value.span}>
              <StyledTitle level={5}>
                {value.label}{" "}
                {value.require && <span className="text-danger ml-1">(*)</span>}
              </StyledTitle>
              <Form.Item
                name={value.field}
                rules={[
                  {
                    required: value.require,
                    message: `Chọn ${value.label.toLowerCase()}`,
                  },
                ]}
              >
                <ECourseSelect
                  form={form}
                  allValue={allValue}
                  setAllValue={setAllValue}
                  disabledAll={disabledAll}
                />
              </Form.Item>
            </Col>
          );
        }

        if (value.field === "eTrainingType") {
          return (
            <Col span={value.span}>
              <StyledTitle level={5}>
                {value.label}{" "}
                {value.require && <span className="text-danger ml-1">(*)</span>}
              </StyledTitle>
              <Form.Item
                name={value.field}
                rules={[
                  {
                    required: value.require,
                    message: `Chọn ${value.label.toLowerCase()}`,
                  },
                ]}
              >
                <ETrainingTypeSelect
                  form={form}
                  allValue={allValue}
                  setAllValue={setAllValue}
                  disabledAll={disabledAll}
                />
              </Form.Item>
            </Col>
          );
        }

        if (value.type === INPUT_TYPE.TEXT) {
          return (
            <Col span={value.span}>
              <StyledTitle level={5}>
                {value.label}{" "}
                {value.require && <span className="text-danger">(*)</span>}
              </StyledTitle>
              <Form.Item
                name={value.field}
                rules={[
                  {
                    required: value.require,
                    message: `Nhập ${value.label.toLowerCase()}`,
                  },
                  ...(value?.rules ? value?.rules : []),
                ]}
                initialValue={value?.defaultValue ? value?.defaultValue : null}
              >
                <Input
                  type={value.subType ? value.subType : "text"}
                  className="font-weight-normal"
                  disabled={!!value.disabled || !!disabledAll}
                  placeholder={value.placeholder}
                />
              </Form.Item>
            </Col>
          );
        }

        if (value.type === INPUT_TYPE.TEXT_AREA) {
          return (
            <Col span={value.span}>
              <StyledTitle level={5}>
                {value.label}{" "}
                {value.require && <span className="text-danger">(*)</span>}
              </StyledTitle>
              <Form.Item
                name={value.field}
                rules={[
                  {
                    required: value.require,
                    message: `Nhập ${value.label.toLowerCase()}`,
                  },
                  ...(value?.rules ? value?.rules : []),
                ]}
                initialValue={value?.defaultValue ? value?.defaultValue : null}
              >
                <TextArea
                  className="font-weight-normal"
                  disabled={!!value.disabled || !!disabledAll}
                  rows={value.rows ? value.rows : 3}
                />
              </Form.Item>
            </Col>
          );
        }

        if (value.type === INPUT_TYPE.SELECT) {
          if (value.field === "eDepartment") {
            return (
              <Col span={value.span}>
                <StyledTitle level={5}>
                  {value.label}{" "}
                  {value.require && (
                    <span className="text-danger ml-1">(*)</span>
                  )}
                </StyledTitle>
                <Form.Item
                  name={value.field}
                  rules={[
                    {
                      required: value.require,
                      message: `Chọn ${value.label.toLowerCase()}`,
                    },
                  ]}
                  initialValue={
                    value?.defaultValue ? value?.defaultValue : null
                  }
                >
                  <Select
                    options={value.options}
                    disabled={
                      !!value.disabled || !!disabledAll || mode === "edit"
                    }
                    placeholder={value.placeholder ? value.placeholder : null}
                  />
                </Form.Item>
              </Col>
            );
          }

          return (
            <Col span={value.span}>
              <StyledTitle level={5}>
                {value.label}{" "}
                {value.require && <span className="text-danger ml-1">(*)</span>}
              </StyledTitle>
              <Form.Item
                name={value.field}
                rules={[
                  {
                    required: value.require,
                    message: `Chọn ${value.label.toLowerCase()}`,
                  },
                ]}
                initialValue={value?.defaultValue ? value?.defaultValue : null}
              >
                <Select
                  options={value.options}
                  disabled={!!value.disabled || !!disabledAll}
                  placeholder={value.placeholder ? value.placeholder : null}
                />
              </Form.Item>
            </Col>
          );
        }

        if (value.type === INPUT_TYPE.DATE_TIME) {
          return (
            <Col span={value.span}>
              <StyledTitle level={5}>
                {value.label}{" "}
                {value.require && <span className="text-danger ml-1">(*)</span>}
              </StyledTitle>
              <Form.Item
                name={value.field}
                rules={[
                  {
                    required: value.require,
                    message: `Chọn ${value.label.toLowerCase()}`,
                  },
                ]}
                initialValue={
                  value.defaultValue
                    ? moment(value.defaultValue, "YYYY-MM-DD")
                    : undefined
                }
              >
                <DatePicker
                  showTime
                  style={{ width: "100%" }}
                  disabled={disabledAll ? true : false}
                />
              </Form.Item>
            </Col>
          );
        }
      })}
    </>
  );
}

export function RenderApprover({
  department,
  form,
}: {
  department: string;
  form: any;
}) {
  const employees = useSelector((state: any) => state.employee.employees).map(
    (value: any) => {
      return {
        ...value,
        label: value.Title + " | " + value.eMail,
        value: value.eMail + "|" + value.Title,
      };
    }
  );

  const [employeeOptions, setEmployeeOptions] = useState(employees);

  const [pickedUser, setPickedUser] = useState<any>("");

  useEffect(() => {
    form.resetFields(["eApprovedBy"]);

    const selectedDepartmentValue = departments.find(
      (e: any) => e.value === department
    );

    const newEmployees = [...employees];
    let approverTitleCode = "TP,PP,GD,PGĐ";

    setEmployeeOptions(
      newEmployees.filter(
        (value) =>
          approverTitleCode.indexOf(value.eBizTitleCode) > -1 &&
          value.eDepartmentCode == selectedDepartmentValue?.id
      )
    );
  }, [department]);

  return (
    <>
      <Col span={12}>
        <StyledTitle level={5}>
          Người duyệt{" "}
          {pickedUser === "" && <span className="text-danger">(*)</span>}
        </StyledTitle>
        <Form.Item
          name="eApprovedBy"
          rules={[
            {
              required: !pickedUser || pickedUser === "",
              message: "Chọn người duyệt",
            },
          ]}
        >
          <Select options={employeeOptions} placeholder="Thủ trưởng CQ/ĐV" />
        </Form.Item>
      </Col>

      <Col span={12}>
        <StyledTitle level={5}>Người duyệt thay thế</StyledTitle>
        <AlternateApproverSelect
          placeholder="Thủ trưởng CQ/ĐV"
          onChange={(value) => {
            if (value) {
              setPickedUser(value);
              form.setFieldValue("pickedUser", value);
            } else {
              setPickedUser("");
              form.setFieldValue("pickedUser", "");
            }
          }}
        />
      </Col>

      <Col span={0}>
        <Form.Item name="pickedUser">
          <Input />
        </Form.Item>
      </Col>
    </>
  );
}

export function RenderCreateFormButton({ homePath }: { homePath: string }) {
  const history = useHistory();

  return (
    <Col span={24}>
      <div className="d-flex justify-content-center">
        <StyledButton
          bgColor="red"
          htmlType="submit"
          onClick={() => history.push(homePath)}
          danger
          type="primary"
        >
          Hủy
        </StyledButton>

        <StyledButton
          bgColor="yellow"
          type="primary"
          htmlType="submit"
          className="ml-3"
        >
          Xác nhận
        </StyledButton>
      </div>
    </Col>
  );
}

export function RenderUnit({
  department,
  form,
  span,
  mode,
}: {
  department: string;
  form: any;
  span: number;
  mode?: string;
}) {
  const [units, setUnits] = useState<any[]>([]);

  useEffect(() => {
    if (mode === "create") form.resetFields(["eUnit"]);

    let selectedDepartment = departments.filter(
      (value) => value.value == department
    )?.[0];

    if (!selectedDepartment) {
      setUnits([]);
      form.setFieldValue("eUnit", null);
    } else if (selectedDepartment.id === 2) {
      setUnits(unitNB);
      if (mode === "create") form.setFieldValue("eUnit", null);
    } else if (selectedDepartment.id === 3) {
      setUnits(unitDN);
      if (mode === "create") form.setFieldValue("eUnit", null);
    } else if (selectedDepartment.id === 1) {
      setUnits(unitTSN);
      if (mode === "create") form.setFieldValue("eUnit", null);
    } else {
      setUnits([
        { value: selectedDepartment.id, label: selectedDepartment.value },
      ]);
      if (mode === "create") form.setFieldValue("eUnit", selectedDepartment.id);
    }
  }, [department]);

  return (
    <Col span={span}>
      <StyledTitle level={5}>
        Đơn vị <span className="text-danger">(*)</span>
      </StyledTitle>
      <Form.Item
        name="eUnit"
        rules={[{ required: true, message: "Chọn chi nhánh" }]}
      >
        <Select
          options={units}
          placeholder={"Chọn chi nhánh"}
          disabled={mode === "edit"}
        />
      </Form.Item>
    </Col>
  );
}

export function RenderProgress({ progress }: { progress: any[] }) {
  return (
    <>
      {progress.map((value) => (
        <div className="item">
          {value.status === requestStatus.approved && (
            <div className={`step approved`}>
              <FontFa name="faCheck" />
            </div>
          )}

          {value.status === requestStatus.rejected && (
            <div className={`step rejected`}>
              <FontFa name="faBan" />
            </div>
          )}

          {value.status === requestStatus.submitted && (
            <div className={`step waiting`}>
              <FontFa name="faCheck" />
            </div>
          )}

          <div className="content">
            <div className="rank">
              <h6>{value.title}</h6>
            </div>
            <div className="title">{value.name}</div>
            <div className="title">{value.email}</div>
            {[requestStatus.approved, requestStatus.rejected].includes(
              value.status
            ) && (
              <div className="time">{`Ngày duyệt: ${getDDMMYYYFormat(
                value.approvedDate
              )} - ${getHHmmFormat(value.approvedDate)}`}</div>
            )}
          </div>
        </div>
      ))}
    </>
  );
}

export function RenderApprovalHistory({ history }: { history: any[] }) {
  return (
    <>
      {history.map((value: any) => (
        <>
          {value.status === requestStatus.approved && (
            <div className="py-2 pl-3">
              <p>
                <span className="font-weight-bold">
                  {value.title}, {value.name}
                </span>{" "}
                đã phê duyệt lúc {getDDMMYYYFormat(value.approvedDate)} -{" "}
                {getHHmmFormat(value.approvedDate)}
                {value.comment && <>,{" " + value.comment}</>}
              </p>
            </div>
          )}

          {value.status === requestStatus.rejected && (
            <div className="py-2 pl-3">
              <p>
                <span className="font-weight-bold">
                  {value.title}, {value.name}
                </span>{" "}
                đã từ chối lúc {getDDMMYYYFormat(value.approvedDate)} -{" "}
                {getHHmmFormat(value.approvedDate)}
                {value.comment && <>,{" " + value.comment}</>}
              </p>
            </div>
          )}
        </>
      ))}
    </>
  );
}

export function RenderComment({
  form,
  disabled,
}: {
  form: any;
  disabled: boolean;
}) {
  return (
    <Form form={form}>
      <Form.Item name="comment">
        <StyledTitle level={5}>Comments</StyledTitle>
        <Input.TextArea
          onChange={(e) => {
            form.setFieldsValue({
              comment: e.target.value,
            });
          }}
          disabled={disabled}
        />
      </Form.Item>
    </Form>
  );
}

export function getUnitFromUnitID(department: string, unitID: string) {
  let selectedDepartment = departments.filter(
    (value) => value.value == department
  )?.[0];
  let Units: any[] = [];


  if (!selectedDepartment) {
    return "";
  } else if (selectedDepartment.id === 2) {
    Units = unitNB;
  } else if (selectedDepartment.id === 3) {
    Units = unitDN;
  } else if (selectedDepartment.id === 1) {
    Units = unitTSN;
  } else {
    return selectedDepartment.value;
  }

  return (
    Units.filter((value) => value.id === unitID || value.value === unitID)?.[0]
      ?.value || ""
  );
}